
import PostView from "../components/PostView";
import UserLayout from "../components/UserLayout";

const PostViewPage = () => {
    return (
        <UserLayout>
            <PostView />
        </UserLayout>
    );
}

export default PostViewPage;